import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import { EventsFilterDTO } from "utils/helpers/models/host-dtos/events-filter.dto";
import { EventDTO } from "utils/helpers/models/shared/event.dto";
import EventCard from "components/cards/event-card";
import { useSelector } from "react-redux";
import Pagination from "components/pagination";
import noFoundGif from "assets/images/gifs/noFoundGif.gif";
import CustomMessageDisplay from "components/data-not-found/CustomMessageDisplay";
import AttendeeBreadcrumb, {
  AttendeBreadcrumbLink,
} from "components/breadcrumbs/AttendeeBreadcrumb";
import useAmbassador from "containers/ambassador/useHooks";

const AmbassadorExperiencesFollow = () => {
  const breadcrumbLinks: AttendeBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.ambassadorHome },
    {
      title: "Follow Up Experiences",
      path: siteRoutes.ambassadorfollowExperiences,
    },
  ];

  const navigate = useNavigate();
  const { getEventFollowUp } = useAmbassador()
  const [data, setData] = useState<EventDTO[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const followBtn = true

  const [filters, setFilters] = useState<EventsFilterDTO>(() => {
    const defaultFilters = new EventsFilterDTO();
    defaultFilters.size = 12;
    defaultFilters.page = 0;
    return defaultFilters;
  });

  const getAllEvents = (filters: EventsFilterDTO, clearData: boolean = false) => {
    // Clear data before fetching if requested (for pagination)
    if (clearData) {
      setData([]);
    }
    
    const queryParams: any = {};
    for (let key in filters) {
      if (
        filters[key]?.toString() &&
        filters[key] !== "" &&
        key !== "totalElements" &&
        key !== "totalPages"
      ) {
        queryParams[key] = filters[key];
      }
    }
    getEventFollowUp(setData, queryParams, setFilters);

    // Mark initial load as complete after first API call
    if (isInitialLoad) {
      setIsInitialLoad(false);
    }
  };

  useEffect(() => {
    getAllEvents(filters);
  }, []);

  const goToExpDetail = (id: number) => {
    navigate(`${siteRoutes.experienceDetail}?id=${id}`);
  };

  const handlePageChange = (pageInfo: { selected: number; limit: number }) => {
    const newFilters = { ...filters };
    newFilters.page = pageInfo.selected;
    newFilters.size = pageInfo.limit;
    setFilters(newFilters);
    getAllEvents(newFilters, true); // Pass true to clear data before fetching
  };
  


  return (
    <div className="container min-h-[70vh] mb-4">
      <AttendeeBreadcrumb links={breadcrumbLinks} />
      <h2 className="text-2xl text-blackie font-bold my-4">Experiences</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 my-6">
        {data.map((event, index) => (
          <EventCard event={event} key={index} followBtn={followBtn} />
        ))}
      </div>

      <div className="flex items-center justify-center ">
        <CustomMessageDisplay
          show={!isLoading && !data.length && !isInitialLoad}
          title="No Follow Up Experiences"
          slogan="You have no follow up experiences at the moment. Your follow up experiences will appear here once they're available."
          image={noFoundGif}
          imageAlt="No experiences found"
          className="py-12"
          imageClassName="w-24 h-24"
          titleClassName="text-2xl font-bold text-blackie"
          sloganClassName="text-gray-500 text-base"
        />
      </div>

      {data?.length > 0 && (
        <Pagination
          count={filters.totalElements}
          page={filters.page}
          limit={filters.size}
          onPageChange={handlePageChange}
          activeBgColor={"#DE9C27"}
          activeTextColor={"#ffffff"}
        />
      )}
    </div>
  );
};

export default AmbassadorExperiencesFollow;
